import { render, staticRenderFns } from "./dev-use-elec.vue?vue&type=template&id=474d66ca&scoped=true&"
import script from "./dev-use-elec.vue?vue&type=script&lang=js&"
export * from "./dev-use-elec.vue?vue&type=script&lang=js&"
import style0 from "./dev-use-elec.vue?vue&type=style&index=0&id=474d66ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474d66ca",
  null
  
)

export default component.exports